const images = {
  after: null,
  first: 36,
  search: undefined,
  categoryId: undefined,
};

export default images;
